export enum AccountantsQueryKeys {
    ACCOUNTANTS = "ACCOUNTANTS"
};